import React from 'react'
import { useRouter } from 'next/router'

// next components
import Image from 'next/image'

import GradientButton from 'components/Button/GradientButton'
import OutlineButton from 'components/Button/OutlineButton'
import ImageWithFoster from 'components/ImageWithFoster'

// custom functions
import { useViewport } from 'utils'

// images and icons
import AvatarImage from 'assets/images/dashboard-avatar.png'
import TwitterWhiteIcon from 'assets/icons/twitter-white-15x15.svg?component'
import WebsiteIcon from 'assets/icons/website-icon-15x15.svg?component'
import IGWhiteIcon from 'assets/icons/instagram-white-15x15.svg?component'
import DripIcon from 'assets/icons/drip-icon-15x15.svg?component'
import LandIcon from 'assets/icons/land-icon-15x15.svg?component'
import SolrPlexIcon from 'assets/icons/solrplex-white-icon.svg?component'

// styles
import styles from './index.module.scss'
import { getDisplayUserName } from 'utils/strings'
import Link from 'next/link'

const EcosystemCard = props => {
  const { data } = props

  const router = useRouter()
  const viewport = useViewport()
  return (
    <div className={styles.container}>
      <div className={styles.topSection}>
        <div className="min-w-[76px] min-h-[76px] sm:min-w-[90px] sm:min-h-[90px]">
          {data.artist.profile_picture ? (
            <ImageWithFoster
              width={viewport === 'xs' ? 76 : 90}
              height={viewport === 'xs' ? 76 : 90}
              src={data.artist.profile_picture}
              className="rounded-[10px]"
            />
          ) : (
            <Image
              src={AvatarImage}
              width={viewport === 'xs' ? 76 : 90}
              height={viewport === 'xs' ? 76 : 90}
              className="rounded-[10px]"
              alt=""
            />
          )}
        </div>
        <div className="w-full flex flex-col gap-[5px] sm:gap-[12px] ">
          <div className={styles.artistName}>
            {data.artist.username ? getDisplayUserName(data.artist.username) : 'Ecosystem'}
          </div>
          {data.artist?.bio?.length > 0 && <div className={styles.description}>{data.artist.bio}</div>}
        </div>
      </div>
      <div className="w-full p-[20px] sm:p-[25px]">
        <div className={styles.border} />
        <div className="w-full flex justify-between items-center my-[15px] gap-[15px]">
          <div className="flex flex-wrap gap-[15px]">
            <div className="flex items-center gap-[4px] lg:gap-2">
              <div className={styles.text}>{data.number_of_categories ?? 0}</div>
              <div className={styles.title}>Collections</div>
            </div>
            <div className="flex items-center gap-[4px] lg:gap-2">
              <div className={styles.text}>{data.number_of_nfts ?? 0}</div>
              <div className={styles.title}>Artworks</div>
            </div>
          </div>
          <div className="gap-[10px] 2xl:gap-[15px] sm:flex hidden">
            {data.artist.three_land_url?.length > 0 && (
              <div className={styles.socialIcon} onClick={() => window.open(data.artist.three_land_url)}>
                <LandIcon />
              </div>
            )}

            {data.artist.twitter_url?.length > 0 && (
              <div className={styles.socialIcon} onClick={() => window.open(data.artist.twitter_url)}>
                <TwitterWhiteIcon />
              </div>
            )}

            {data.artist.ig_url?.length > 0 && (
              <div className={styles.socialIcon} onClick={() => window.open(data.artist.ig_url)}>
                <IGWhiteIcon />
              </div>
            )}

            {data.artist.site_url?.length > 0 && (
              <div className={styles.socialIcon} onClick={() => window.open(data.artist.site_url)}>
                <WebsiteIcon />
              </div>
            )}
          </div>
        </div>
        <div className={styles.border} />
        <div className="w-full flex gap-[15px] mt-[15px]">
          <Link href={`/${data.artist.username}/merch`} passHref>
            <a className="w-full">
              <GradientButton fullWidth label="Shop Merch" onClick={() => {}} />
            </a>
          </Link>
          <Link href={`/${data.artist.username}`} passHref>
            <a className="w-full">
              <OutlineButton
                fullWidth
                label="Visit Profile"
                onClick={() => {
                  router.push(`/${data.artist.username}`)
                }}
              />
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default EcosystemCard
